export default {
  primary: '#20409d',
  negative: 'rgb(210, 62, 70)',
  positive: 'rgb(0, 168, 79)',
  neutral: 'grey',
}